import { Product } from './products.class';
export class ProductsResponse {
  count: number;
  errors: number;
  products: Product[];
}
